import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ProductReport from '../../productsReport/productReport.jsx';
import Report from './reports.jsx';
export default (
  <Route path="relatorio-tc">
    <IndexRoute component={(props) => <Report {...props} />} />
    <Route path=":id">
      <IndexRoute component={(props) => <ProductReport {...props} />} />
    </Route>
  </Route>
);
